import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "region-select" }
const _hoisted_2 = ["id"]
const _hoisted_3 = {
  key: 2,
  class: "region-select__status"
}
const _hoisted_4 = {
  key: 3,
  class: "region-select__error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_select = _resolveComponent("n-select")!
  const _component_n_button = _resolveComponent("n-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isFixed)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: _ctx.selectId,
          class: "region-select__static"
        }, _toDisplayString(_ctx.regions[0].name), 9, _hoisted_2))
      : (_openBlock(), _createBlock(_component_n_select, {
          key: 1,
          id: _ctx.selectId,
          value: _ctx.modelValue,
          options: _ctx.options,
          loading: _ctx.loading,
          disabled: _ctx.disabled || _ctx.loading || _ctx.failed,
          status: _ctx.invalid ? 'error' : 'default',
          placeholder: "Select a region",
          filterable: "",
          "onUpdate:value": _ctx.onSelect,
          onBlur: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('blur')))
        }, null, 8, ["id", "value", "options", "loading", "disabled", "status", "onUpdate:value"])),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Loading regions…"))
      : _createCommentVNode("", true),
    (_ctx.failed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createTextVNode(" Could not load your regions. "),
          _createVNode(_component_n_button, {
            text: "",
            type: "primary",
            disabled: _ctx.loading,
            onClick: _ctx.load
          }, {
            default: _withCtx(() => [
              _createTextVNode("Retry")
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ]))
      : _createCommentVNode("", true)
  ]))
}